module.exports = __webpack_public_path__ + "static/media/linkedin_white.237f06d5.svg";